import { Box, Grid, Typography, Card, CardContent, styled, Button } from "@mui/material";
import Header from "../../../components/Header";
import API from "../../../api";
import { useEffect, useState } from "react";
import {
  InfoCard,
  MalwareList,
  URLList,
  PassiveDNSList,
} from "./ipInspection-comp";
import { useLocation } from "react-router-dom";
import { colors } from "../../../theme";
import MediumTypog from "../../../components/mediumTypog";
import CircularIndeterminate from "../../../components/circularProgress";


const StyledCard = styled(Card)`
  flex: 1;
  width: auto;
  background-color: #1E1E1E;
  background-image: none;
  border-radius: 15px;
  /* border: 3px solid #449095; */
`;


const IpInspection = () => {
  const [data, setData] = useState();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const ip = queryParams.get("ip");
  const [charged, setCharged] = useState(false)

  useEffect(() => {
    API.getIpInspection({ ip: ip })
      .then((response) => {
        setData(response.data);
        setCharged(true)
      })
      .catch((err) => {
        console.error('[IpInspection] failed to fetch IP inspection data:', err);
        setCharged(true)
      });
  }, [ip]);

  return (
    <Box m="20px">
      <Box display="flex" alignItems="center">
        <Header title="IP Inspection" subtitle="" />
      </Box>
      <Box>
        <Button variant="contained" sx={{
          backgroundColor: "#2d2d2d !important",
          mt: 3,
          "&:hover": {
            backgroundColor: "#eaeaea !important",
            color: "#131C2D",
          },
        }}
        onClick={() => {window.location.href = "./map"}}
        >MAP</Button>
      </Box>
      {data && data.length !== 0 ? <Grid container spacing={2}>
        <Grid xs={12} md={4} mt={5}>
          <InfoCard ip={data && data.ip} location={data && data.location} />
        </Grid>

        <Grid
          mt={5}
                    xs={12}
          md={10}
          sx={{
            height: { xs: "250px", md: "2px", lg: "286px" },
            marginBottom: 5,
          }}
        >
          <StyledCard>
            <CardContent>
              <Grid
                overflow="auto"
                sx={{ height: { xs: "110%", md: "286px", lg: "286px" } }}
                className="highlights"
              >
                <Grid
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  borderBottom={`2px solid #eaeaea`}
                  colors={colors.grey[100]}
                  p={1}
                  position="sticky"
                  top={0}
                  zIndex={1}
                  bgcolor={"#1E1E1E"}
                >
                  <MediumTypog
                    title={`Last 5 URL Associated (Total: ${data && data.count_url_list
                      })`}
                  />
                </Grid>
                <Grid
                  display="flex"
                  alignItems="center"
                  borderBottom={`2px solid #eaeaea`}
                  colors={colors.grey[100]}
                  p={1}
                  position="sticky"
                  top={52}
                  zIndex={1}
                >
                  <Typography
                    color={colors.grey[100]}
                    variant="h5"
                    fontWeight="600"
                    sx={{
                      width: { lg: "80vh", xs: "10vh" },
                      marginLeft: { lg: "240px", xs: "10%" },
                    }}
                  >
                    Date
                  </Typography>
                  <Typography
                    color={colors.grey[100]}
                    variant="h5"
                    fontWeight="600"
                    sx={{
                      width: { lg: "80vh", xs: "10vh" },
                      marginLeft: { lg: "90px", xs: "40%" },
                    }}
                  >
                    URL
                  </Typography>
                </Grid>
                <URLList urlList={data && data.last_5_url_list} />
              </Grid>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid
                    mt={5}
          xs={12}
          md={10}
          sx={{
            height: { xs: "250px", md: "2px", lg: "286px" },
            marginBottom: 5,
          }}
        >
          <StyledCard>
            <CardContent>


              <Grid
                overflow="auto"
                sx={{ height: { xs: "110%", md: "286px", lg: "286px" } }}
                className="highlights"
              >

                <Grid
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  borderBottom={`2px solid #eaeaea`}
                  colors={colors.grey[100]}
                  bgcolor="#1E1E1E"
                  p={1}
                  position="sticky"
                  top={0}
                  zIndex={1}
                >
                  <MediumTypog
                    title={`Last 5 Passive DNS Associated (Total: ${data && data.count_passive_dns
                      })`}
                  />
                </Grid>
                <Grid
                  display="flex"
                  alignItems="center"
                  borderBottom={`2px solid #eaeaea`}
                  colors={colors.grey[100]}
                  p={1}
                  position="sticky"
                  top={52}
                  zIndex={1}
                >
                  <Typography
                    color={colors.grey[100]}
                    variant="h5"
                    fontWeight="600"
                    sx={{
                      width: { lg: "80vh", xs: "10vh" },
                      marginLeft: { lg: "240px", xs: "10%" },
                    }}
                  >
                    Last Date
                  </Typography>
                  <Typography
                    color={colors.grey[100]}
                    variant="h5"
                    fontWeight="600"
                    sx={{
                      width: { lg: "80vh", xs: "10vh" },
                      marginLeft: { lg: "90px", xs: "50%" },
                    }}
                  >
                    HostName
                  </Typography>
                </Grid>
                <PassiveDNSList passiveDns={data && data.last_5_passive_dns} />
              </Grid>
            </CardContent>
          </StyledCard>
        </Grid>
        <Grid
          mt={5}
                    xs={12}
          md={10}
          sx={{
            height: { xs: "250px", md: "2px", lg: "286px" },
            marginBottom: 5,
          }}
        >
          <StyledCard>
            <CardContent>


              <Grid
                overflow="auto"
                sx={{ height: { xs: "250px", md: "286px", lg: "286px" } }}
                className="highlights"
              >
                <Grid
                  display="flex"
                  alignItems="center"
                  borderBottom={`2px solid #eaeaea`}
                  colors={colors.grey[100]}
                  bgcolor="#1E1E1E"
                  p={1}
                  position={"sticky"}
                  top={0}
                  zIndex={1}
                >
                  <MediumTypog
                    title={`Last 5 Example Malware Associated (Total: ${data && data.count_malware
                      })`}
                  />
                </Grid>
                <Grid
                  display="flex"
                  alignItems="center"
                  borderBottom={`2px solid #eaeaea`}
                  colors={colors.grey[100]}
                  p={1}
                  position="sticky"
                  top={52}
                  zIndex={1}
                >
                  <Typography
                    color={colors.grey[100]}
                    variant="h5"
                    fontWeight="600"
                    sx={{
                      width: { lg: "80vh", xs: "10vh" },
                      marginLeft: { lg: "240px", xs: "10%" },
                    }}
                  >
                    Date
                  </Typography>
                  <Typography
                    color={colors.grey[100]}
                    variant="h5"
                    fontWeight="600"
                    sx={{
                      width: { lg: "80vh", xs: "10vh" },
                      marginLeft: { lg: "90px", xs: "50%" },
                    }}
                  >
                    Hash/Detection
                  </Typography>
                </Grid>
                <MalwareList malware={data && data.last_5_malware} />
              </Grid>
            </CardContent>
          </StyledCard>
        </Grid>
      </Grid> : <CircularIndeterminate charged={charged} />}
    </Box>
  );
};

export default IpInspection;
